/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBounce = createReactComponent("outline", "arrow-bounce", "IconArrowBounce", [["path", { "d": "M10 18h4", "key": "svg-0" }], ["path", { "d": "M3 8a9 9 0 0 1 9 9v1l1.428 -4.285a12 12 0 0 1 6.018 -6.938l.554 -.277", "key": "svg-1" }], ["path", { "d": "M15 6h5v5", "key": "svg-2" }]]);

export { IconArrowBounce as default };
//# sourceMappingURL=IconArrowBounce.mjs.map
